module.exports = __webpack_public_path__ + "media/outgoing-connecting.6dfb37b5.wav";